var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalMantenedor',{attrs:{"show":_vm.show}},[_c('CabeceraModal',{attrs:{"titulo":"Contacto Ejecutivo"},on:{"cerrar":_vm.handleCerrar}}),_c('ContenidoModal',[_c('ContactarEjecutivoForm',{attrs:{"isVerDetalle":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }